export const getFileExt = (filename = "") => {
  const array = filename.split(".");
  return array[array.length];
};
